import BaseCollectiveLogListItem from './BaseCollectiveLogListItem'
import { ICollectiveLogListItemProps } from './common'

const CollectiveLogDataOnVoteChanged: React.FC<
  ICollectiveLogListItemProps<'CollectiveLogDataOnVoteChanged'>
> = ({ bundledCollectiveLog, isLast }) => (
  <BaseCollectiveLogListItem
    bundle={bundledCollectiveLog}
    isLast={isLast}
    summaryActionText={`changed their vote on`}
    singleProposalText={`proposal`}
    detailsActionText={() => `changed their vote on`}
    summaryManyProposalText={count => ` ${count} proposals`}
  />
)

export default CollectiveLogDataOnVoteChanged
